module.exports = __webpack_public_path__ + "img/surfaceshowcase.1c6685ba.jpg";